export default __webpack_public_path__ + "static/media/single-corner-rectangle.25779ac8.svg";